import React from 'react';
import { Box } from '@mui/material';

type WrapperProps = {
  width?: string;
  height?: string;
  svgStyles?: any;
  props?: any;
  element?: React.FC<any>;
};

export const SVGWrapper = (ChildSvg: React.FC) => {
  return ({ width, height, element, svgStyles, ...props }: WrapperProps) => {
    const Element = element;

    if (Element) {
      return (
        <Element
          {...props}
          sx={{
            '& > svg': {
              width: width ?? null,
              height: height ?? null,
              ...svgStyles,
            },
          }}>
          <ChildSvg />
        </Element>
      );
    }
    return (
      <Box
        {...props}
        sx={{
          '& > svg': {
            width: width ?? null,
            height: height ?? null,
            ...svgStyles,
          },
        }}>
        <ChildSvg />
      </Box>
    );
  };
};